
import React from 'react';
import { Button } from '@/components/ui/button';
import { Music, Video, Image as ImageIcon, FileText, FolderPlus, Upload } from 'lucide-react';

interface EmptyMediaStateProps {
  activeTab?: string;
  hasFilters?: boolean;
  type?: string;
  message?: string;
  description?: string;
}

const EmptyMediaState: React.FC<EmptyMediaStateProps> = ({ 
  activeTab = 'all', 
  hasFilters = false,
  type,
  message,
  description
}) => {
  const mediaType = type || activeTab;
  const displayMessage = message || (hasFilters ? 'No files match your filters' : `No ${mediaType} files found`);
  const displayDescription = description || (hasFilters 
    ? 'Try adjusting your search or filters'
    : `Upload your ${mediaType === 'all' ? 'media' : mediaType} files to get started`);

  return (
    <div className="text-center py-12">
      {mediaType === 'audio' && <Music className="h-16 w-16 mx-auto mb-4 opacity-20" />}
      {mediaType === 'video' && <Video className="h-16 w-16 mx-auto mb-4 opacity-20" />}
      {(mediaType === 'image' || mediaType === 'artwork') && <ImageIcon className="h-16 w-16 mx-auto mb-4 opacity-20" />}
      {mediaType === 'document' && <FileText className="h-16 w-16 mx-auto mb-4 opacity-20" />}
      {mediaType === 'all' && <FolderPlus className="h-16 w-16 mx-auto mb-4 opacity-20" />}
      
      <h3 className="text-lg font-medium mb-2">{displayMessage}</h3>
      <p className="text-muted-foreground mb-6">{displayDescription}</p>
      
      <Button className="gap-2">
        <Upload className="h-4 w-4" />
        <span>Upload Files</span>
      </Button>
    </div>
  );
};

export default EmptyMediaState;
